import { withLocalState } from 'pyradux';

import AcceptedContainer from './Accepted.container';
import reducer from './Accepted.reducer';
import AcceptedSagas from './Accepted.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'accepted',
  sagas: [AcceptedSagas],
};

export default withLocalState(withLocalStateOptions, AcceptedContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Ebay/OAuth/Accepted/index.js